import { SUBCATEGORIES_API, SUBCATEGORY_STAT_API } from '../../../../Utilities/APIs'
import PcNSCRUD from '../../../Partials/Layouts/CRUDs/CRUDLayouts/NSCRUD/PcNSCRUD'

function SubcategoryStatCards() {
  return (
    <PcNSCRUD
        // parentChild props
        parentDBField={'subcategory'}

        // common props
        api={SUBCATEGORY_STAT_API}
        screenTopicSingular={'Subcategory Stat'}
        screenTopicPlural={'Subcategory Stats'}
        
        // crud header props
        showTotalInHeading
        
        // crud props
        allowCreate
        allowUpdate
        allowDelete
        
        // select props
        selectApi={SUBCATEGORIES_API}
        selectType={'parent-child'}
        selectDBField={'subcategory'}
        selectName={'Subcategory'}
    />
  )
}

export default SubcategoryStatCards